
const _ = require('lodash');
const $ = require('jquery');


const jqueryMethodsWhitelist = _.fromPairs(_.map([
	'next',
	'prev',
	'parent',
], function (method) {
	return [method, true];
}));

module.exports = function getTargetFromAttr ($trigger, attr) {
	const target = $trigger.attr(attr) || '';

	let $target;
	if (target.startsWith('$')) {
		const methods = _.filter(target.split('$'), _.identity);
		$target = _.reduce(methods, function (tgt, method) { // apply methods one after another
			if (!tgt) {
				return null;
			}
			if (!jqueryMethodsWhitelist[method]) {
				return null;
			}
			return tgt[method]();
		}, $trigger);
	}

	return $target || $(target);
};
